module.exports = __webpack_public_path__ + "img/06.8e20e263.jpg";